import { X } from "lucide-react";

import CopyToClipboard from "@components/ui-components/copy-to-clipboard";

// Neither endpoint returns a password once it is set, so whatever was created
// in this session stays on screen with its credentials until it is dismissed or
// the page is left. Used by both the ops and the brand-login steps.
const CreatedCredentials = ({ rows, title, onDismiss }) => {
    if (!rows.length) return null;

    return (
        <div className="rounded-xl border border-success/20 bg-success/5 p-4">
            <div className="text-sm font-medium text-gray-900">{title}</div>
            <p className="mt-0.5 text-xs text-muted">
                Passwords are never returned by the API — copy them before leaving the page.
            </p>
            <ul className="mt-3 space-y-2">
                {rows.map((row) => (
                    <li
                        key={row.id}
                        className="flex flex-wrap items-center gap-x-3 gap-y-1 rounded-lg border border-gray-200 bg-white px-3 py-2 text-sm">
                        <span className="font-medium text-gray-900">{row.name}</span>
                        {row.meta && <span className="text-xs text-muted">{row.meta}</span>}
                        <span className="text-muted">{row.email}</span>
                        <span className="ml-auto flex items-center gap-1.5 text-xs">
                            <code className="rounded bg-light px-1.5 py-0.5 text-gray-700">{row.password}</code>
                            <CopyToClipboard text={row.password} id={`cred-${row.id}`} width={13} />
                            <button
                                type="button"
                                onClick={() => onDismiss(row.id)}
                                aria-label="Dismiss"
                                className="ml-1 text-gray-400 hover:text-gray-700">
                                <X className="h-3.5 w-3.5" />
                            </button>
                        </span>
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default CreatedCredentials;
